/** Production API default when `VITE_LUMORA_API` is unset at build time (#671). */
export const LUMORA_PROD_API_BASE_URL = "https://api.lumorasites.com";
/** Public R2 bucket base (lumora-media) for object keys like `tenants/...`. */
export const LUMORA_PROD_MEDIA_BASE_URL = "https://pub-377a591731b24d0f904285111f9cf04f.r2.dev";
/** Shared localStorage adapter for LumoraClient token persistence. */
export function localStorageTokens(key) {
    function loadTokens() {
        try {
            if (typeof localStorage === "undefined")
                return null;
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : null;
        }
        catch {
            return null;
        }
    }
    return {
        getTokens: loadTokens,
        onTokens: (tokens) => {
            if (typeof localStorage === "undefined")
                return;
            if (tokens)
                localStorage.setItem(key, JSON.stringify(tokens));
            else
                localStorage.removeItem(key);
        },
    };
}
//# sourceMappingURL=localStorageTokens.js.map